module.exports = __webpack_public_path__ + "img/bg_function05_2_m.7534711a.svg";